import { useUser } from '@auth0/nextjs-auth0/client';
import { Col, Form, Input, Row, Select } from 'antd';
import { useRouter } from 'next/router';
import styled from 'styled-components';

const WidgetVoter = ({ labelCode, disabled, help, score, isError, showButton, onClick, showCode = true }) => {
  const { user } = useUser(); // ดึงข้อมูลผู้ใช้จาก Auth0

  const router = useRouter();

  const avatar = user?.picture;
  const email = user?.email; // เพิ่มบรรทัดนี้

  return (
    <>
      <Container className='widget-voter'>
        <Row gutter={16} justify='center'>
          {
            user ?
            <>
          <Col xs={4} md={6} className='avatar-container'>
            {avatar ? (
              <a className='avatar-default' href={`/api/auth/logout?returnTo=${router.asPath}`} rel='noopener noreferrer' >
                {/* <LogoutOutlined size={22} /> */}

                <img src={avatar} alt={'img'} width={55} height={55} />
                <span className='help'> logout </span>
              </a>
            ) : ( 
             <></>
              // <a className='btn-login avatar-default' href={`/api/auth/login?returnTo=${router.asPath}`} rel='noopener noreferrer'>
              //   {/* <a className='btn-login avatar-default' href={`/api/auth/login`} rel='noopener noreferrer'> */}
              //   <FaUser size={22} />
              //   <span className='help'> login </span>
              // </a>
            )}
          </Col>
               <Col xs={20} md={9}>
                <Form.Item
                  name={['voter', 'voter_email']}
                  // label='อีเมล์'
                  className='custom-title'
                  rules={[
                    { pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, message: 'กรอกอีเมล์' },
                    { required: true, message: 'กรุณากรอกอีเมล์' }
                  ]}
                >
                  <Input
                    className='custom-input'
                    placeholder='E-Mail:'
                    maxLength={254}
                    minLength={5}
                    disabled={!!email}  // เปลี่ยนเฉพาะบรรทัดนี้ - disabled เมื่อมี email
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item
                  name={['voter', 'voter_age']}
                  // label='อายุ'
                  className='custom-title'
                  rules={[
                    { pattern: /^[0-9]{1,2}$/, message: 'กรอกเฉพาะตัวเลข 1-99' },
                    { required: true, message: 'กรุณากรอกอายุ' }
                  ]}
                >
                  <Input
                    className='custom-input'
                    placeholder='Age:'
                    maxLength={2}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={5}>
                <Form.Item
                  name={['voter', 'voter_gender']}
                  // label='เบอร์'
                  className='custom-title'
                  rules={[
                    { required: true, message: 'กรุณาเลือกเพศ' }
                  ]}
                >
                  <Select className='custom-input' placeholder='Gender:' >
                    <Select.Option value='male'>Male</Select.Option>
                    <Select.Option value='female'>Female</Select.Option>
                    <Select.Option value='-'>ไม่ระบุ</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            </>
            :
            // <Col md={24}>
                <ContainerLogin> 
              <a className='btn-login avatar-default' href={`/api/auth/login?returnTo=${router.asPath}`} rel='noopener noreferrer'>
                เข้าสู่ระบบเพื่อโหวต CEO ที่คุณชื่นชอบ 
              </a>
              </ContainerLogin>
            // </Col>
          }
       
        </Row>
      </Container>
    </>
  );
};

const ContainerLogin = styled.div`
cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background:  linear-gradient(90deg, #ab8000 0%,  #f2ca46 100%);
  border-radius: 14px;
  height: 65px;
  font-weight: 600;
  font-size: 22px;
  box-shadow: rgba(100,100,111,0.2) 0px 7px 29px 0px;
  /* margin: 0 10px; */
        margin: 0px;

  a {
    color: #000;
  }
  &:hover {
    opacity: 0.8;
  }
  @media (max-width: 768px) {
   font-size: 18px;
 a {
    /* color: #000; */
    font-size: 18px;

  }
 }
@media (max-width: 375px) {
  font-size: 14px;
  margin: 0;
  padding: 0;
  a {
      /* color: #000; */
      font-size: 16px;

    }
  }
`;
const Container = styled.div`
  width: 100%;
  max-width: 1260px;
  min-height: 100px;
  margin: 20px auto 0 auto;
  padding: 0 10px;
  @media (max-width: 767px) {
    max-width: 100%;
    margin: 20px 0 ;
    padding: 0 10px;
  }
  .ant-row-center {
    justify-content: space-between;
    padding: 0px;
    @media (max-width: 767px) {
      padding: 0;
    }
  }
  .avatar-container{
    position: relative;
    cursor: pointer;
    border-radius: 50%;
    background:  linear-gradient(90deg, #ab8000 0%,  #f2ca46 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    /* overflow: hidden; */
    max-width: 65px;
    height: 65px;
    padding: 0;
    .help {
      position: absolute;
      bottom: -23px;
      color: #faad14;
      z-index: 100;
    }
    .avatar-default,
    .avatar-default > img {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      color: #a0a0a0;
    }
    .avatar-default svg {
      stroke: #000;
      fill: #000;
    }
    @media (max-width: 767px) {
      max-width: 55px;
      height: 55px;
      margin-top: 5px;
        .avatar-default > img {
        width: 45px;
        height: 45px;
        }
    }
    
  }
  input,
  input[placeholder] {
    text-align: center;
  }
  .ant-form-item-has-error
    :not(.ant-input-disabled):not(.ant-input-borderless).ant-input {
    border-color: white;
  }
  .custom-title {
    position: relative;
    background:  rgb(36 31 35) ;
    background:  linear-gradient(90deg, #ab8000 0%,  #f2ca46 100%);
    margin-bottom: 25px;
    border-radius: 16px;
    /* border: 0px solid rgba(230, 187, 127, 0.92); */
    .ant-form-item-control  {
      padding: 5px;
    }
    .ant-form-item-explain.ant-form-item-explain-error {
      display: flex;
      justify-content: center;
      color: #fff;
    }
    .ant-form-item-explain.ant-form-item-explain-success {
      color: #58C058;
      display: flex;
      justify-content: center;
      font-weight: 700;
    }
    .ant-form-item-label {
      padding: 0px;
      border-radius: 13px 13px 0 0 ;
      background: linear-gradient(
        90deg,
        #fdc773 -0.7%,
        #fdc679 35.8%,
        #fddfa5 44.93%,
        #faefcf 56.08%,
        #ffdb95 65.21%,
        #fbc068 78.39%,
        #f0b35d 84.47%,
        #d49141 95.63%,
        #c78235 100.7%
      );

      .ant-form-item-required {
        background-color: #050B09;
        margin: 3px;
        border-radius: 10px 10px 0 0 ;
      }
    }

    label {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFF;
      font-size: 22px;
      line-height: 1.75;
      padding: 0 10px;
      font-weight: 400;
      background-color: #720101;
      border-radius: 10px 10px 0 0 ;
    }
    .ant-select {
      padding: 4px 10px !important;
    }
    .custom-input {
      color:#000 ;
      font-size: 20px;
      letter-spacing: 1px;
      font-weight: 400;
      background-color: #fff;
      padding: 0px 15px;
      text-align: start;
      height: 55px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      /* border-radius: 0px 0px 5px 5px; */
      border-radius: 12px;
      border: none;
      position: relative;
      @media (max-width: 768px) {
        font-size: 18px;

      }
      /* @media (max-width: 475px) {
        font-size: 18px;
        
      } */
      .ant-select-selector {
        border: unset;
        padding-left: 0px;
        span {
          /* color: #ad8104; */
          font-weight: 400;
          font-size: 20px;
          height: 50px;
          display: flex;
          align-items: center;
      }

        }
        .ant-select-selection-placeholder {
          line-height: 3;
            @media (max-width: 767px) {
          line-height: 1.8;
        
      }
        }
      }
      ::placeholder {
        color: #ad8104;
        font-weight: 400;
        font-size: 16px;

      }
      }
  .check-code-row {
    margin-top: -10px;
    margin-bottom: 20px;
    .ant-col {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
  }
  .check-code {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    padding: 4px 16px;

    background: #050B09;
    transition: 0.75s all;

    span {
      font-weight: 600;
      font-size: 20px;
      color:  rgba(230, 187, 127, 0.92);
    }
    &:hover {
      span {
      color: #050B09;
      }
      background: linear-gradient(
        90deg,
        #a77630 25%,
        #ac7c35 38%,
        #bb8d43 55%,
        #d4a95b 75%,
        #f7d07b 97%,
        #fdd781 100%
    );
    }
  }
  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background: transparent;
  }
`;
export default WidgetVoter;
